type GuideNavigator = (to: string) => void;

let navigator: GuideNavigator | null = null;
let pendingTo: string | null = null;

/**
 * Register the app router. Returns an unregister function. A navigate action
 * that fires before the bridge mounts is replayed once.
 */
export function registerGuideNavigator(navigate: GuideNavigator): () => void {
  navigator = navigate;
  if (pendingTo !== null) {
    const to = pendingTo;
    pendingTo = null;
    navigate(to);
  }
  return () => {
    if (navigator === navigate) navigator = null;
  };
}

export function guideNavigate(to: string): void {
  if (navigator) {
    navigator(to);
    return;
  }
  pendingTo = to;
}

/** Test helper: drop a queued navigation and the current registrar. */
export function resetGuideNavigator(): void {
  navigator = null;
  pendingTo = null;
}
